import { render, staticRenderFns } from "./complaintsListingComponent.vue?vue&type=template&id=f51483bc&"
import script from "./complaintsListingComponent.vue?vue&type=script&lang=js&"
export * from "./complaintsListingComponent.vue?vue&type=script&lang=js&"
import style0 from "./complaintsListingComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports